/**
 * Metadatos de estado del Cliente (US-2.3) — Admin Web.
 *
 * Mismo contrato que `ally-status.ts`: etiqueta + color + `colorDark` + `iconKey`,
 * para que el consumidor nunca dependa solo del color (WCAG). El tipo `CustomerStatus`
 * se deriva del contrato OpenAPI en `@goelectric/shared-types`.
 */
import type { CustomerStatus } from '@goelectric/shared-types';
import { darkColors, semanticColors } from '../tokens';
import type { StatusIconKey } from './station-status';

export interface CustomerStatusMeta {
  /** Etiqueta visible (obligatoria: no solo color). */
  label: string;
  description: string;
  /** Color para tema claro. */
  color: string;
  /** Color ajustado para tema oscuro. */
  colorDark: string;
  iconKey: StatusIconKey;
}

/** Estado de gestión de la cuenta del cliente (`Customer.status`). */
export const CUSTOMER_STATUS_META: Record<CustomerStatus, CustomerStatusMeta> = {
  ACTIVE: {
    label: 'Activo',
    description: 'Cuenta habilitada para operar y cargar saldo.',
    color: semanticColors.success,
    colorDark: darkColors.success,
    iconKey: 'check',
  },
  SUSPENDED: {
    label: 'Suspendido',
    description: 'Cuenta suspendida en el CRM: estado administrativo, no bloquea la carga ni el saldo.',
    color: semanticColors.danger,
    colorDark: darkColors.danger,
    iconKey: 'warning',
  },
};
